import(/* webpackMode: "eager" */ "/home/autofrance.se/next-autofrance/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/autofrance.se/next-autofrance/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/autofrance.se/next-autofrance/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/home/autofrance.se/next-autofrance/src/components/CampaignBanner.tsx");
;
import(/* webpackMode: "eager" */ "/home/autofrance.se/next-autofrance/src/components/HeroSlider.tsx");
;
import(/* webpackMode: "eager" */ "/home/autofrance.se/next-autofrance/src/components/HomeContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeHeroV2"] */ "/home/autofrance.se/next-autofrance/src/components/HomeHeroV2.tsx");
;
import(/* webpackMode: "eager" */ "/home/autofrance.se/next-autofrance/src/components/LocaleLink.tsx");
;
import(/* webpackMode: "eager" */ "/home/autofrance.se/next-autofrance/src/components/ProductRecommendationSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecentlyViewedSection"] */ "/home/autofrance.se/next-autofrance/src/components/RecentlyViewedSection.tsx");
